'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withWindow = require('../helpers/withWindow');

var _withWindow2 = _interopRequireDefault(_withWindow);

var _FavoritesMenu = require('./FavoritesMenu');

var _FavoritesMenu2 = _interopRequireDefault(_FavoritesMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withWindow2.default)(_FavoritesMenu2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FavoritesMenu/index.js
// module id = 581
// module chunks = 11